import { CtxMapV2 } from 'components/mapV2/contexts/CtxMapV2';
import { MapV2ModalDetailCompact } from 'components/mapV2/MapV2Modal/elements/MapV2ModalDetailCompact';
import { MapV2ModalDetailContent } from 'components/mapV2/MapV2Modal/elements/MapV2ModalDetailContent';
import { MapV2ModalDetailHeader } from 'components/mapV2/MapV2Modal/elements/MapV2ModalDetailHeader';
import { ScrollVertical } from 'elements/functional/ScrollVertical';
import { DetailQuery_moment } from 'graphql/query/__generated__/DetailQuery';
import { WorldMapMarkerStory_worldMapView_markers } from 'graphql/query/__generated__/WorldMapMarkerStory';
import { useContext } from 'react';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    story: DetailQuery_moment;
    marker: WorldMapMarkerStory_worldMapView_markers | null;
    height: string;
}

const HEADER_HEIGHT = 48;

export const MapV2ModalDetail = (props: Props): JSX.Element => {
    const ctxMapV2 = useContext(CtxMapV2);
    const isWide = ctxMapV2.isWide;

    if (!props.story) {
        return null;
    }

    return (
        <S_MapV2ModalDetail className={props.className} $isWide={isWide}>
            {!isWide && ctxMapV2.mobileModalState.size === 'small' ? (
                <MapV2ModalDetailCompact story={props.story} />
            ) : (
                <>
                    <MapV2ModalDetailHeader />
                    <S_ScrollVertical
                        light
                        $height={`calc(${props.height} - ${HEADER_HEIGHT}px)`}
                        stopPropagation
                    >
                        <S_Content $isWide={isWide}>
                            <MapV2ModalDetailContent story={props.story} marker={props.marker} />
                        </S_Content>
                    </S_ScrollVertical>
                </>
            )}
        </S_MapV2ModalDetail>
    );
};

const S_MapV2ModalDetail = styled.div<{ $isWide: boolean }>`
    margin-top: ${(props) => (props.$isWide ? '0' : '0px')};
    background: ${(props) => (props.$isWide ? 'rgba(246, 247, 245, 0.9)' : 'transparent')};
`;

const S_ScrollVertical = styled(ScrollVertical)<{ $height: string }>`
    height: ${(props) => props.$height};

    &::-webkit-scrollbar {
        width: 6px;
    }
`;

const S_Content = styled.div<{ $isWide: boolean }>`
    padding-bottom: ${(props) => (props.$isWide ? '0' : '60px')};
    height: 100%;
`;
